fx.ns("desktop.common.behaviour", class PageDragger extends fx.EventDispatcher {

    // TODO : rewrite this code
    constructor(board) {
        super();

        this.board = board;


        this._draggData = {};

        this.overPage = null;

        this.SCROLLMARGIN = 50;

        this.disable();
    }


    enable() {
        if (this.enabled)
            return;

        super.enable();

        this.on("mousedown", this._onMouseDown, this.board);
        this.on("scrolled", this._onScroll, this.board);

    }

    disable() {
        if (!this.enabled)
            return;

        super.disable();

        this.off("mousedown", this._onMouseDown, this.board);
        this.off("scrolled", this._onScroll, this.board);

    }

    _listenMouse(val) {
        if (val) {
            this.on("mousemove", this._onMouseMove, window);
            this.on("mouseup", this._onMouseUp, window);
            this.on("blur", this._onMouseUp, window);
        }
        else {
            this.off("mousemove", this._onMouseMove, window);
            this.off("mouseup", this._onMouseUp, window);
            this.off("blur", this._onMouseUp, window);
        }
    }

    _onMouseDown(event) {
        if (fx.dom.parent(event.target, ".IconButton"))
            return;

        let page = fx.dom.parent(event.target, ".BookArea");

        if (page)
            page = this.board.getArea(page.id);

        if (!page)
            return;

        this.board.currentArea = page; // set active area

        this._listenMouse(true);
    }

    _onMouseMove(event) {
        if (!this._draggData.dragging)
        {
            if (fx.dom.parent(event.target, ".IconButton"))
                return;
    
            let page = fx.dom.parent(event.target, ".BookArea");
    
            if (page)
                page = this.board.getArea(page.id);
    
            if (!page)
                return;
    
            if (page.data.isCover)
                return;
    
            let ratio = 0.7;
    
            let childs = this.board.allChilds;
            let index = childs.indexOf(page);
            let previousChild = childs[index-1];
            let nextChild = childs[index+1];
            if (previousChild)
                fx.dom.addClass(previousChild, "hide");
            if (nextChild)
                fx.dom.addClass(nextChild, "hide");
    
            this._draggData.page = page;
            this._draggData.previousChild = previousChild;
            this._draggData.nextChild = nextChild;
            this._draggData.dragging = true;
            this._draggData.startPosition = this.board.currentView.getPosition(page);
            this._draggData.position = { x: event.pageX, y: event.pageY };
    
            let mousePosition = fx.graphics.globalToLocal(this.board, event.pageX, event.pageY);
    
            this._draggData.elementStartPosition = {};
            this._draggData.elementStartPosition.scale = this._draggData.startPosition.scale * ratio;
            this._draggData.elementStartPosition.x = mousePosition.x / this._draggData.startPosition.scale / ratio - this._draggData.page.width() / 2;
            this._draggData.elementStartPosition.y = (mousePosition.y + this.board.scrollPosition) / this._draggData.startPosition.scale / ratio - this._draggData.page.height() / 2;
    
            this._draggData.page.css({ "opacity": 0.5, "transform": "scale(" + this._draggData.elementStartPosition.scale + ") translate(" + this._draggData.elementStartPosition.x + "px," + this._draggData.elementStartPosition.y + "px)" });
            this._draggData.page.css({ "transition": "", "z-index": 1 });
    
            this._draggData.offset = {
                offsetX: event.pageX / (this._draggData.elementStartPosition.scale) - (this._draggData.elementStartPosition.x),
                offsetY: (event.pageY + this.board.scrollPosition) / (this._draggData.elementStartPosition.scale) - (this._draggData.elementStartPosition.y)
            };
    
            this._draggData.page.dragging(true);
    
            this.trigger("dragstart");
        }
        else
        {

            let x = (event.pageX / (this._draggData.elementStartPosition.scale) - this._draggData.offset.offsetX);
            let y = ((event.pageY + this.board.scrollPosition) / (this._draggData.elementStartPosition.scale) - this._draggData.offset.offsetY);

            this._draggData.page.css({ "transform": "scale(" + (this._draggData.elementStartPosition.scale) + ") translate(" + x + "px, " + y + "px)" });
            this._draggData.mousePosition = { x: event.pageX, y: event.pageY };

            let elements = fx.graphics.underElements(event);

            let overComponent = elements.filter(a => fx.dom.parent(a, ".AddPageComponent"))[0];
            if (overComponent)
                overComponent = fx.dom.parent(overComponent, ".AddPageComponent")

            if (this._draggData.overComponent)
                fx.dom.removeClass(this._draggData.overComponent, "over");

            if (overComponent) {
                this._draggData.overComponent = overComponent;
                fx.dom.addClass(this._draggData.overComponent, "over");
            }


            this.trigger("dragmove");

            this._scroll(event);
        }
    }


    _onMouseUp(event) {

        this._listenMouse(false);

        if (!this._draggData.dragging)
            return;

        this.trigger("dragstop");


        if (this._draggData.overComponent) {
            fx.dom.removeClass(this._draggData.overComponent, "over");
            let component = this.board.getChild(this._draggData.overComponent.id)
            this.trigger({ type: "dragdrop", page: this._draggData.page, overPage: component, side: "right" });
        }
        else {
            this._draggData.page.css({ "transform": "scale(" + this._draggData.startPosition.scale + ") translate(" + this._draggData.startPosition.x + "px, " + this._draggData.startPosition.y + "px)" });
        }

        this._draggData.page.css({ "opacity": 1, "transition": "", "z-index": 0 });


        this.delay(this._animationFinished, 250);

        if (this.scrollTimerDown) {
            this.repeat(this._scrollDown, null);
            this.scrollTimerDown = null;
        }

        if (this.scrollTimerUp) {
            this.repeat(this._scrollUp, null);
            this.scrollTimerUp = null;
        }
    }


    _scroll(event) {
        if (event.pageY > this.board.realHeight - this.SCROLLMARGIN) {

            if (!this.scrollTimerDown)
                this.scrollTimerDown = this.repeat(this._scrollDown, 5);

            if (this.scrollTimerUp) {
                this.delay(this._scrollUp, null);
                this.scrollTimerUp = null;
            }

        }
        else
            if (event.pageY < this.SCROLLMARGIN) {

                if (!this.scrollTimerUp)
                    this.scrollTimerUp = this.repeat(this._scrollUp, 5);

                if (this.scrollTimerDown) {
                    this.repeat(this._scrollDown, null);
                    this.scrollTimerDown = null;
                }
            }
            else {
                if (this.scrollTimerDown) {
                    this.repeat(this._scrollDown, null);
                    this.scrollTimerDown = null;
                }

                if (this.scrollTimerUp) {
                    this.repeat(this._scrollUp, null);
                    this.scrollTimerUp = null;
                }
            }
    }

    _onScroll() {
        if (this._draggData.mousePosition) {
            let x = (this._draggData.mousePosition.x / (this._draggData.page.scale) - this._draggData.offset.offsetX);
            let y = ((this._draggData.mousePosition.y + this.board.scrollPosition) / (this._draggData.page.scale) - this._draggData.offset.offsetY);

            this._draggData.page.css({ "transform": "scale(" + this._draggData.page.scale + ") translate(" + x + "px, " + y + "px)" });
        }
    }

    _animationFinished() {
        this._draggData.page.dragging(false);

        if (this._draggData.previousChild)
            fx.dom.removeClass(this._draggData.previousChild, "hide");
        if (this._draggData.nextChild)
            fx.dom.removeClass(this._draggData.nextChild, "hide");

        this._draggData = {};
    }

    _scrollUp() {
        if (!this.board.canScrollTop)
            return;

        this.board.scroll("-4", false);
    }

    _scrollDown() {
        if (!this.board.canScrollBottom)
            return;

        this.board.scroll("+4", false);
    }


});
